import { Injectable } from '@angular/core';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { AppConfigService } from './app-config.service';
import { CurrentInfoService } from './current-info.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService 
{
  constructor
  (
    private appconfigservice: AppConfigService,
    private currentinfoservice: CurrentInfoService,
    private analytics: AngularFireAnalytics,
  ) { }

  initialized=false;

  public initialize()
  {
    if(this.initialized)
      return;
      
    if(this.currentinfoservice._currentInfo.PixelID.length > 0)
      (window as any).fbq('init', this.currentinfoservice._currentInfo.PixelID);

    this.initialized = true;
  }

  public facebookTrack(event:string, data:any = undefined)
  {
    if(data)
      (window as any).fbq('trackCustom', `${event}`, data);
    else
      (window as any).fbq('trackCustom', `${event}`);
  }

  public track(event:string, data:any = undefined)
  {
    if(data)
      this.analytics.logEvent(event); 
    else
      this.analytics.logEvent(event, data); 
  }
}
